export class RelayError extends Error {
  constructor(reason) {
    const errorMsg = `Failed to relay operation to window broker. (Reason: ${reason})`;
    super(errorMsg);
    this.reason = reason;
  }
}
RelayError.Reason = {
  GET_TOPIC_SUBS_MISSING_PORT: "Can't obtain topic subscriptions. Missing port.",
  NO_LINK_SET: 'No link found when relaying message',
  HANDSHAKE_NOT_COMPLETED: 'Handshake not completed',
  OPERATION_TIMEOUT: 'Operation timed out',
  ORIGIN_NOT_ALLOWED: 'Origin not allowed',
  ORIGIN_NOT_RETRIEVED: 'Failed to probe for origin'
};